import ajax from "../../authenticationSafeAjax";

const AUTH_API_URL = "/disclosure/api/auth";

export function requestDisclosureAuthenticationStatus(callback) {
    ajax({ url: AUTH_API_URL }, (code, response) => {
        if (code === 404) {
            callback({emailAddress: null});
        } else {
            const authenticationStatus = JSON.parse(response);
            callback(authenticationStatus);
        }
    });
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/actions/disclosureAuthenticationRequests.js
 **/